import { cn as e } from "../lib/utils.js";
import * as t from "react";
import { cva as n } from "class-variance-authority";
import { jsx as r } from "react/jsx-runtime";
import { Slot as i } from "@radix-ui/react-slot";
//#region src/shadcn/button.tsx
var a = n("inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium transition-all focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", {
	variants: {
		variant: {
			default: "bg-brand-background text-brand-foreground hover:bg-brand-backgroundHover",
			accent: "bg-brand-background text-brand-foreground hover:bg-brand-backgroundHover",
			destructive: "bg-negative-background text-negative-foreground hover:bg-negative-backgroundHover active:bg-negative-backgroundPress",
			outline: "border border-solid border-border bg-white hover:bg-core-backgroundHover",
			secondary: "bg-coreMuted-background text-coreMuted-foreground hover:bg-coreMuted-backgroundHover",
			muted: "bg-coreMuted-background text-coreMuted-foreground hover:bg-coreMuted-backgroundHover",
			ghost: "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
			link: "text-primary underline-offset-4 hover:underline",
			askBranded: "text-white bg-gradient-to-br from-blue-700 to-sky-400 shadow-lg border-2 border-border hover:from-blue-700 hover:shadow-xl hover:to-blue-500 disabled:from-gray-600 disabled:to-gray-600 disabled:shadow-none disabled:opacity-100"
		},
		size: {
			default: "h-8 px-3 py-2 rounded-md text-base",
			sm: "h-7 px-2 rounded-md text-sm",
			xs: "h-6 px-1 rounded-md text-xs",
			lg: "h-10 px-3 rounded-md text-md",
			icon: "h-8 w-8 rounded-md"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), o = t.forwardRef(({ className: t, variant: n, size: o, asChild: s = !1, ...c }, l) => /* @__PURE__ */ r(s ? i : "button", {
	className: e(a({
		variant: n,
		size: o
	}), t),
	ref: l,
	...c
}));
o.displayName = "Button";
//#endregion
export { o as Button, a as buttonVariants };
